"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprintRequiredActionsDecoder = exports.computedOnCompletionDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
var sprint_1 = require("../data/sprint");
var timestamp_1 = __importDefault(require("./timestamp"));
exports.computedOnCompletionDecoder = ts_data_json_1.JsonDecoder.object({
    totalEffortEstimated: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.number),
    totalEffortCompleted: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.number),
    totalTasks: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.number),
    totalTasksCompleted: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.number),
}, 'Sprint.ComputedOnCompletion');
exports.SprintRequiredActionsDecoder = ts_data_json_1.JsonDecoder.enumeration(sprint_1.SprintRequiredActions, 'SprintRequiredActions');
exports.default = ts_data_json_1.JsonDecoder.object({
    sprintNumber: ts_data_json_1.JsonDecoder.number,
    sprintName: ts_data_json_1.JsonDecoder.string,
    description: ts_data_json_1.JsonDecoder.string,
    startDate: timestamp_1.default,
    endDate: timestamp_1.default,
    isComplete: ts_data_json_1.JsonDecoder.boolean,
    completedAt: ts_data_json_1.JsonDecoder.nullable(timestamp_1.default),
    computedOnCompletion: exports.computedOnCompletionDecoder,
    archived: ts_data_json_1.JsonDecoder.boolean,
    deleted: ts_data_json_1.JsonDecoder.boolean,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
    remainingTasksCount: ts_data_json_1.JsonDecoder.number,
    totalTasksCount: ts_data_json_1.JsonDecoder.number,
    teamId: ts_data_json_1.JsonDecoder.string,
    orderedTaskIds: ts_data_json_1.JsonDecoder.array(ts_data_json_1.JsonDecoder.string, 'TaskId[]'),
    carryOverTaskIds: ts_data_json_1.JsonDecoder.array(ts_data_json_1.JsonDecoder.string, 'TaskId[]'),
    requiresAction: ts_data_json_1.JsonDecoder.nullable(exports.SprintRequiredActionsDecoder),
}, 'Sprint');
